import React, { useEffect, useState } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { Form } from "react-bootstrap";
import axios from "axios";
import noThumbnail from "../../assets/noThumbnail.png";



// const MediaItem = (props) => {
//   const { media, onClose } = props;
//   let { mediaId, month, year, path, size, type, description } = media;
//   const [image, setImage] = useState(noThumbnail);
//   description =
//     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum";
//   useEffect(() => {
//     console.log(media);
//     console.log("/api/medium/thumbnail/media/" + media.mediaId);
//     axios.get("/api/medium/thumbnail/media/" + mediaId).then((res) => {
//       setImage(res.data);
//     });
//   }, [media]);

//   const handleClose = (ev) => {
//     onClose && onClose();
//   };


 const MediaItem = (props) => {
  const { media, onClose } = props;
  const [image, setImage] = useState(noThumbnail);
  const [editableMedia, setEditableMedia] = useState({ 
    ...media,
    crf: media.crf || 23,
    rotate: media.rotate || 0,
    red: media.red || 0,
    green: media.green || 0,
    blue: media.blue || 0,
    saturation: media.saturation || 1,
    t: media.t || 10
  });

  useEffect(() => {
    axios.get("/api/medium/thumbnail/media/" + media.mediaId)
      .then((res) => setImage(res.data))
      .catch(() => setImage(noThumbnail));
  }, [media]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditableMedia((prev) => ({ ...prev, [name]: value }));
  };

  
  const handleUpdate = async () => {
    try {
      await axios.post("/api/media/save-edit", editableMedia);
      alert("Edits saved!");
  
      // 🔁 Reload the saved edits
      const response = await axios.get(`/api/media/get-edit/${editableMedia.mediaId}`);
      setEditableMedia((prev) => ({
        ...prev,
        ...response.data,
      }));
    } catch (err) {
      console.error("Failed to save or refresh edits", err);
      alert("Save failed.");
    }
  };
  
  // const handleUpdate = () => {
  //   axios.post("/api/media/save-edit", editableMedia)
  //     .then(() => {
  //       alert("Edits saved to 'edit' collection");
  //       onClose && onClose();
  //     })
  //     .catch((err) => console.error("Failed to save edits", err));
  // };

  return (
    <Card>
      <Card.Header>
        <div className="d-flex justify-content-between">
          <div>Media Item</div>
          <div className="link" onClick={onClose}>X</div>
        </div>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={4}>
            <img
              className="img-fluid"
              src={image}
              alt=""
              style={{
                transform: `rotate(${editableMedia.rotate || 0}deg)`,
                filter: `
                  saturate(${editableMedia.saturation || 1})
                  drop-shadow(0 0 0 rgb(${editableMedia.red || 0}, ${editableMedia.green || 0}, ${editableMedia.blue || 0}))
                `
              }}
            />
          </Col>
          <Col md={8}>
            <Form.Group className="row">
              <Form.Label className="col-4">ID</Form.Label>
              <div className="col-8"><p>{editableMedia.mediaId}</p></div>
            </Form.Group>
            <Form.Group className="row">
              <Form.Label className="col-4">Path</Form.Label>
              <div className="col-8">
                <Form.Control name="path" value={editableMedia.path} onChange={handleChange} />
              </div>
            </Form.Group>
            <Form.Group className="row">
              <Form.Label className="col-4">Description</Form.Label>
              <div className="col-8">
                <Form.Control as="textarea" rows="4" name="description" value={editableMedia.description} onChange={handleChange} />
              </div>
            </Form.Group>
            {/* Optional: add inputs for rotate, red, green, blue, saturation */}
            <Form.Group className="row">
              <Form.Label className="col-4">Rotate</Form.Label>
              <div className="col-8">
                <Form.Control type="number" name="rotate" value={editableMedia.rotate} onChange={handleChange} />
              </div>
            </Form.Group>
            <Form.Group className="row">
              <Form.Label className="col-4">Saturation</Form.Label>
              <div className="col-8">
                <Form.Control type="number" name="saturation" value={editableMedia.saturation} onChange={handleChange} />
              </div>
            </Form.Group>
            <Form.Group className="row">
              <Form.Label className="col-4">Red</Form.Label>
              <div className="col-8">
                <Form.Control type="number" name="red" value={editableMedia.red} onChange={handleChange} />
              </div>
            </Form.Group>
            <Form.Group className="row">
              <Form.Label className="col-4">Green</Form.Label>
              <div className="col-8">
                <Form.Control type="number" name="green" value={editableMedia.green} onChange={handleChange} />
              </div>
            </Form.Group>
            <Form.Group className="row">
              <Form.Label className="col-4">Blue</Form.Label>
              <div className="col-8">
                <Form.Control type="number" name="blue" value={editableMedia.blue} onChange={handleChange} />
              </div>
            </Form.Group>
            <Form.Group className="row">
              <Form.Label className="col-4">CRF</Form.Label>
              <div className="col-8">
                <Form.Control type="number" name="crf" value={editableMedia.crf} onChange={handleChange} />
              </div>
            </Form.Group>
            <Form.Group className="row">
            <Form.Label className="col-4">Duration (seconds)</Form.Label>
                <div className="col-8">
                 <Form.Control 
                  type="number"
                  name="t"
                  value={editableMedia.t}
                  onChange={handleChange}
                  min={1}
                  max={60}
                />
                </div>
            </Form.Group>
            <Form.Group className="row mt-3">
              <div className="d-flex justify-content-end w-100">
                <Button onClick={handleUpdate}>Update</Button>
              </div>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
export default MediaItem;



